module.exports = __webpack_public_path__ + "img/JunNishimura_企画書_ページ_07.aee3f00e.jpg";